import styled from "styled-components";

export const SignStatus = styled.div<{ $status?: string }>`
  min-width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${(props) => {
    switch (props.$status) {
      case "loading":
        return "var(--disabled-bg)";
      case "successAll":
        return "var(--signed-byYou-c)";
      case "success":
        return "var(--signed-byAll-bg)";
      case "failure":
        return "var(--sign-failure)";
      case "cancelled":
        return "var(--status-cancelled)";
      case "readyToSign":
        return "var(--blue)";
      default:
        return "var(--sign-waiting)";
    }
  }};

  color: ${(props) => {
    switch (props.$status) {
      case "loading":
        return "var(--black)";
      case "successAll":
        return "var(--signed-byAll-c)";
      case "success":
        return "var(--signed-byYou-c)";
      case "failure":
        return "var(--red)";
      case "cancelled":
        return "var(--status-cancelled-color)";
      case "readyToSign":
        return "var(--blue)";
      default:
        return "var(--orange)";
    }
  }};
  // white-space: nowrap;
    margin: 5px;
  // font-size: 14px;
  // display: flex;
  // max-width: 182px;
  // & span {
  //   overflow: hidden;
  //   text-overflow: ellipsis;  
  // }

`;
